import makeStyles from '@mui/styles/makeStyles';

interface Props {
  borderRadius: string;
}

const styles = ({ borderRadius }: Props) =>
  makeStyles(() => ({
    accordionWrapper: {
      boxShadow: "none",
      marginTop: 16,
      "&::before": {
        backgroundColor: "transparent !important",
      },
    },
    accordionSummary: {
      backgroundColor: "#edf5fb",
      borderRadius: `${borderRadius}`,
      "& span": {
        font: "700 16px/24px Manrope",
        color: "#465869",
      },
      "&.Mui-expanded": {
        minHeight: "48px",
      },
      "& .MuiAccordionSummary-content.Mui-expanded": {
        margin: "12px 0",
      },
    },
    accordionDetails: {
      border: "1px solid #e4e7ec",
      borderRadius: "0 0 8px 8px",
      paddingTop: 16,
    },
  }));

export default styles;
